import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class LocationGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Location',
            ROUTE_PATH.locationGrid,
            ROUTE_PATH.locationAdd,
            true,
            true,
            10,
            false,
            true,
            ['city_name'],
            true,
            [],
            {
                isDownloadExcel: false, excelFileName: '',
                btnLabel: '',headers: []
            },
            false,
            null,
            false,
            false,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: false }
            
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const name  = new Headers('Name', 'city_name', false, true, 'text');      
        headers.push(name );
     
        return headers;
    }
}